import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type SkeletonProps = BoxProps & {
    variant?: "rectangular" | "circular" | "text";
    animation?: "pulse" | "none";
};

const testId = "Skeleton";
const Skeleton = (props: SkeletonProps) => {
    const { sx, variant = "text", animation = "pulse", ...otherProps } = props;

    const animate = animation === "pulse";

    return (
        <Box
            data-testid={testId}
            className={testId}
            sx={{
                "@keyframes pulse": {
                    "0%": {
                        opacity: 1,
                    },
                    "50%": {
                        opacity: 0.5,
                    },
                    "100%": {
                        opacity: 1,
                    },
                },
                display: "block",
                backgroundColor: "var(--proda-white-130)",
                height: variant === "text" ? "1.2em" : "100%",
                borderRadius: variant === "circular" ? "50%" : "4px",
                ...(animate
                    ? { animation: "pulse 2s ease-in-out infinite" }
                    : {}),
                ...sx,
            }}
            {...otherProps}
        />
    );
};

export default Skeleton;
